import { FlowVersionTarget } from 'flow-schema';

import { type api } from 'common';

export function getSubFlowBlockDefaultConfig(): api.FlowDefinition.SubFlowV1BlockConfig {
  return {
    flowDefinitionId: '',
    flowId: '',
    startDataBlockName: '',
    versionTarget: FlowVersionTarget.Published,
  };
}
